var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuGameColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_596_826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 20,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5H0V15H20V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_596_826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9819L2.40974 11.5579L5.60494 11.5601L3.19377 14.9819H0Z",
    fill: "#FF008C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19434 13.5569L5.49808 14.9994L6.93445 13.0767L5.60311 11.5579L4.19434 13.5569Z",
    fill: "#FF008C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49707 15L9.86422 9.14648H12.9269L8.79587 15H5.49707Z",
    fill: "#FF008C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9263 9.14648L13.5684 11.665L11.1716 14.981L10.5166 12.5425L12.9263 9.14648Z",
    fill: "#FF008C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.165 14.9835L16.6032 7.43644L15.5175 6.85569L19.8772 5L20.0001 9.03175L18.9881 8.56267L14.426 14.9834L11.165 14.9835Z",
    fill: "#FF008C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGameColor);
export default __webpack_public_path__ + "static/media/menu-game-color.1cc5b19152395a675444daa1670359d5.svg";
export { ForwardRef as ReactComponent };